import * as React from 'react'
import { UpdateDiscConflict } from '@/lib/api/company/chartScan'
import { fmt, useChartT } from '../i18n'

// Shown when the server reports that the assigned driver already has activities
// overlapping the chart's day (1:1 with WPF CheckActivitiesBeforeSave). Confirming
// only skips the check — nothing is deleted, the overlapping data is merged.
// Keys mirror server DriverActivity.SourceType.
const SOURCE_LABEL_KEYS: Record<number, { key: string; def: string }> = {
  0: { key: 'sourceDriverCard', def: 'karta kierowcy' },
  1: { key: 'sourceAttestation', def: 'zaświadczenie' },
  2: { key: 'sourceFile', def: 'plik' },
  3: { key: 'sourceChart', def: 'tarczka' },
  5: { key: 'sourceVehicle', def: 'pojazd' },
}

export function ConflictDialog({
  conflicts,
  onCancel,
  onConfirm,
}: {
  conflicts: UpdateDiscConflict[]
  onCancel: () => void
  onConfirm: () => void
}) {
  const T = useChartT()
  return (
    <div
      className="tw-fixed tw-inset-0 tw-z-[2100] tw-flex tw-items-center tw-justify-center tw-bg-black/50"
      onMouseDown={onCancel}
    >
      <div
        className="tw-w-[520px] tw-rounded tw-bg-white tw-p-4 tw-shadow-xl"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <h3 className="tw-mb-2 tw-text-base tw-font-semibold tw-text-red-700">
          {T('conflictTitle', 'Uwaga')}
        </h3>
        <p className="tw-mb-3 tw-text-sm tw-text-slate-700">
          {T(
            'conflictText',
            'Dla wybranego kierowcy w tym dniu istnieją już pokrywające się aktywności.'
              + ' Czy na pewno kontynuować?',
          )}
        </p>
        <ul className="tw-mb-3 tw-max-h-48 tw-overflow-auto tw-rounded tw-border tw-border-slate-200 tw-text-xs">
          {conflicts.map((c, i) => (
            <li
              key={i}
              className="tw-flex tw-justify-between tw-border-b tw-border-slate-100 tw-px-2 tw-py-1 last:tw-border-b-0"
            >
              <span className="tw-font-mono">
                {c.startTime.replace('T', ' ').slice(0, 16)} →{' '}
                {c.endTime.replace('T', ' ').slice(0, 16)}
              </span>
              <span className="tw-text-slate-500">
                {SOURCE_LABEL_KEYS[c.source]
                  ? T(SOURCE_LABEL_KEYS[c.source].key, SOURCE_LABEL_KEYS[c.source].def)
                  : fmt(T('sourceOther', 'źródło {0}'), c.source)}
              </span>
            </li>
          ))}
        </ul>
        <div className="tw-flex tw-justify-end tw-gap-2">
          <button
            onClick={onCancel}
            className="tw-rounded tw-border tw-border-slate-300 tw-px-3 tw-py-1.5 tw-text-sm"
          >
            {T('cancel', 'Anuluj')}
          </button>
          <button
            onClick={onConfirm}
            className="tw-rounded tw-bg-primary tw-px-3 tw-py-1.5 tw-text-sm tw-text-white hover:tw-opacity-90"
          >
            {T('continue', 'Kontynuuj')}
          </button>
        </div>
      </div>
    </div>
  )
}
